export const CancelSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2.5C5.875 2.5 2.5 5.875 2.5 10C2.5 14.125 5.875 17.5 10 17.5C14.125 17.5 17.5 14.125 17.5 10C17.5 5.875 14.125 2.5 10 2.5ZM10 4.16667C11.2917 4.16667 12.5 4.625 13.5 5.33333L5.33333 13.5C4.625 12.5 4.16667 11.2917 4.16667 10C4.16667 6.79167 6.79167 4.16667 10 4.16667ZM10 15.8333C8.70833 15.8333 7.5 15.375 6.5 14.6667L14.6667 6.5C15.375 7.5 15.8333 8.70833 15.8333 10C15.8333 13.2083 13.2083 15.8333 10 15.8333Z"
        fill="#D95069"
      />
    </svg>
  );
};

export const OverViewSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17.4038 8.80875C16.7422 7.09743 15.5936 5.61747 14.1001 4.5518C12.6065 3.48612 10.8335 2.88145 9.00001 2.8125C7.16655 2.88145 5.39347 3.48612 3.89993 4.5518C2.40639 5.61747 1.25785 7.09743 0.596255 8.80875C0.551574 8.93234 0.551574 9.06766 0.596255 9.19125C1.25785 10.9026 2.40639 12.3825 3.89993 13.4482C5.39347 14.5139 7.16655 15.1186 9.00001 15.1875C10.8335 15.1186 12.6065 14.5139 14.1001 13.4482C15.5936 12.3825 16.7422 10.9026 17.4038 9.19125C17.4484 9.06766 17.4484 8.93234 17.4038 8.80875ZM9.00001 14.0625C6.01876 14.0625 2.86876 11.8519 1.72688 9C2.86876 6.14812 6.01876 3.9375 9.00001 3.9375C11.9813 3.9375 15.1313 6.14812 16.2731 9C15.1313 11.8519 11.9813 14.0625 9.00001 14.0625Z"
        fill="#7975B6"
      />
      <path
        d="M9 5.625C8.33249 5.625 7.67997 5.82294 7.12495 6.19379C6.56994 6.56464 6.13735 7.09174 5.88191 7.70844C5.62646 8.32514 5.55963 9.00374 5.68985 9.65843C5.82008 10.3131 6.14151 10.9145 6.61352 11.3865C7.08552 11.8585 7.68689 12.1799 8.34157 12.3102C8.99626 12.4404 9.67486 12.3735 10.2916 12.1181C10.9083 11.8626 11.4354 11.4301 11.8062 10.875C12.1771 10.32 12.375 9.66751 12.375 9C12.375 8.10489 12.0194 7.24645 11.3865 6.61351C10.7536 5.98058 9.89511 5.625 9 5.625ZM9 11.25C8.55499 11.25 8.11998 11.118 7.74997 10.8708C7.37996 10.6236 7.09157 10.2722 6.92127 9.86104C6.75098 9.4499 6.70642 8.9975 6.79323 8.56105C6.88005 8.12459 7.09434 7.72368 7.40901 7.40901C7.72368 7.09434 8.12459 6.88005 8.56105 6.79323C8.99751 6.70642 9.4499 6.75097 9.86104 6.92127C10.2722 7.09157 10.6236 7.37996 10.8708 7.74997C11.118 8.11998 11.25 8.55499 11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25Z"
        fill="#7975B6"
      />
    </svg>
  );
};

export const ReAssignSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.728 2.25 15.75 5.27208 15.75 9C15.75 12.728 12.728 15.75 9 15.75C5.27208 15.75 2.25 12.728 2.25 9Z"
        stroke="#5A9A8F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 9L8.25 11.25L12 7.5"
        stroke="#5A9A8F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SuspendSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.5C3.875 0.5 0.5 3.875 0.5 8C0.5 12.125 3.875 15.5 8 15.5C12.125 15.5 15.5 12.125 15.5 8C15.5 3.875 12.125 0.5 8 0.5ZM8 2.16667C9.29167 2.16667 10.5 2.625 11.5 3.33333L3.33333 11.5C2.625 10.5 2.16667 9.29167 2.16667 8C2.16667 4.79167 4.79167 2.16667 8 2.16667ZM8 13.8333C6.70833 13.8333 5.5 13.375 4.5 12.6667L12.6667 4.5C13.375 5.5 13.8333 6.70833 13.8333 8C13.8333 11.2083 11.2083 13.8333 8 13.8333Z"
        fill="#C8CC66"
      />
    </svg>
  );
};
